<template>
	<form
		ref="form"
		id="form"
		:action="base"
		class="hidden"
		enctype="multipart/form-data"
		method="post"
	>
		<input type="text" name="token" v-model="token" />
		<input type="text" name="data[path]" v-model="path" />
		<input
			type="file"
			name="file"
			ref="file"
			:accept="accept"
			@change="start_upload"
		/>
	</form>
</template>
<script>
	import WBS from 'js/http';
	import is_json from 'js/is_json';
	import axios from 'axios';
	import jQuery from 'jquery';

	import toastr from 'toastr';
	export default {
		data() {
			return {
				base: WBS.url_base,
				token: WBS.access_key('protected-custom-sstUpload'),
			};
		},
		props: {
			accept: {
				default: '*',
			},
			path: {
				default: null,
			},
		},
		methods: {
			open() {
				$(this.$refs.file).click();
			},
			async start_upload(e) {
				var formData = new FormData($('#form').get(0));

				// const test = await $(this.$refs.form).ajaxSubmit({
				// beforeSend: this.beforeSend,
				// uploadProgress: this.uploadProgress,
				// })

				const complete = this.complete;
				const beforeSend = this.beforeSend;
				const uploadProgress = this.uploadProgress;

				const opt = {
					url: 'http://wbs.viasst.com.br/',
					type: 'post',
					data: formData,
					processData: false,
					contentType: false,

					beforeSend: beforeSend,
					uploadProgress: uploadProgress,

					success: function (data, textStatus) {
						const parsedData = JSON.parse(data);
						complete(parsedData);

						uploadProgress(0, 0, 0, 100);
					},

					error: function (jqXHR, textStatus, errorThrown) {
						//if fails
						toastr('Ocorreu um erro ao enviar a imagem!');
					},
				};

				$.ajax(opt);
			},

			beforeSend() {
				this.$emit('progress', 0);
			},
			uploadProgress(e, i, t, p) {
				console.log('e,i,t,p');
				console.log(e, i, t, p);
				this.$emit('progress', p);
			},
			complete(resp) {
				console.log('resp');
				console.log(resp);

				if (resp !== null && resp !== undefined) {
					// resp = JSON.parse(resp.responseText)

					if (resp.status == 'success') {
						this.$emit('complete', resp.data);
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				} else {
					toastr.error('Não foi possível fazer o upload!');
					console.log(resp.responseText);
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/upload.vue